import React from 'react';
import { Button } from './Button';
import { ModalBase } from './ModalBase';

interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
  onOpenContactModal: (subject?: string) => void;
}

const DenunciaCard: React.FC<{
    icon: React.ReactNode;
    title: string;
    description: string;
    onClick: () => void;
}> = ({ icon, title, description, onClick }) => (
    <div className="flex flex-col items-center p-6 bg-white rounded-xl shadow-lg border border-gray-200 hover:shadow-2xl hover:-translate-y-2 transition-all duration-300 h-full">
        <div className="flex-shrink-0 mb-4">
            <div className="flex items-center justify-center h-16 w-16 rounded-full bg-blue-100 text-blue-600">
                {icon}
            </div>
        </div>
        <h3 className="text-lg font-bold text-center text-gray-800 mb-2">{title}</h3>
        <p className="text-gray-600 text-sm text-center leading-relaxed mb-4 flex-grow">{description}</p>
        <Button onClick={onClick} variant="secondary" className="w-full mt-auto">
            Iniciar Consulta
        </Button>
    </div>
);


export const DenunciaModal: React.FC<ModalProps> = ({ isOpen, onClose, onOpenContactModal }) => {
  const handleContactClick = (subject: string) => {
    onClose();
    onOpenContactModal(subject);
  };

  return (
    <ModalBase
      isOpen={isOpen}
      onClose={onClose}
      title="Canal de Denuncias contra la Administración"
      containerClassName="max-w-5xl"
      mainClassName="bg-gray-50"
    >
      <div className="text-center px-4">
        <h2 className="text-3xl font-bold text-gray-800">Da voz a tu reclamación</h2>
        <p className="text-lg text-gray-600 mt-3 mb-10 max-w-3xl mx-auto">
          Este es un espacio para los ciudadanos frente a posibles abusos o malas prácticas. Selecciona el ámbito de la administración y nuestro equipo de expertos analizará tu caso.
        </p>
      </div>

      <div className="grid md:grid-cols-3 gap-8">
        <DenunciaCard
            icon={<span className="material-icons-outlined text-3xl">public</span>}
            title="Denuncia a la Administración Central Ante Europa"
            description="Para irregularidades o incumplimientos de normativas europeas por parte del gobierno central o sus organismos."
            onClick={() => handleContactClick('Denuncia: Administración Central Ante Europa')}
        />
        <DenunciaCard
            icon={<span className="material-icons-outlined text-3xl">corporate_fare</span>}
            title="Denuncia a la Administración Autonómica"
            description="Frente a decisiones o actuaciones de gobiernos autonómicos, consejerías o entidades dependientes."
            onClick={() => handleContactClick('Denuncia: Administración Autonómica')}
        />
        <DenunciaCard
            icon={<span className="material-icons-outlined text-3xl">home_work</span>}
            title="Denuncia a la Administración Local"
            description="Contra ayuntamientos, diputaciones y otras entidades locales por mala praxis, licencias, multas, etc."
            onClick={() => handleContactClick('Denuncia: Administración Local')}
        />
      </div>

       <div className="mt-12 pt-6 border-t border-gray-200 text-center">
            <p className="text-xs text-gray-500">Al iniciar una consulta, aceptas que nuestro equipo legal revise la información proporcionada. Toda la comunicación es confidencial.</p>
            <p className="text-xs text-gray-500 mt-2">Recuerda que antes de poder DENUNCIAR en Europa, tienes que haber agotado la via Administrativa y/o Judicial en España</p>
        </div>
    </ModalBase>
  );
};
